import { combineReducers } from 'redux';
import capture from './capture';
import charge from './charge';
import verifyPaymentAndActivateListing from './verifyPaymentAndActivateListing';
import getPrice from './getPrice';
import details from './details';

export default combineReducers({
    capture, charge, verifyPaymentAndActivateListing, getPrice, details,
});
